<header id="header" class="fixed-top">

  <div class="container">

    <div class="logo float-left">
      <!-- Uncomment below if you prefer to use an image logo -->
      <!-- <h1 class="text-light"><a href="#header"><span>NewBiz</span></a></h1> -->
      <a href="#intro" class="scrollto">
        <img src="../assets/img/logo.jpg" alt="" class="img-fluid"></a>
    </div>

    <nav class="main-nav float-right d-none d-lg-block">
      <ul>
        <li [routerLinkActive]="['active']"><a [routerLink]="['/home']">Home</a></li>       
        <li [routerLinkActive]="['active']"><a [routerLink]="['/services']">Services</a></li>
        <li [routerLinkActive]="['active']"><a [routerLink]="['/products']">Products</a></li>
        <li [routerLinkActive]="['active']"><a [routerLink]="['/careers']">Careers</a></li>
        <li [routerLinkActive]="['active']"><a [routerLink]="['/about-us']">About Us</a></li>
        <li [routerLinkActive]="['active']"><a [routerLink]="['/blog']">Blog</a></li>
        <li [routerLinkActive]="['active']"><a [routerLink]="['/contact-us']">Contact Us</a></li>
         
      </ul>
    </nav><!-- .main-nav -->
    
  </div>
</header>
<div style="margin-top:30px">
   
<router-outlet>
  
</router-outlet>
</div>
  <!--==========================
    Footer
  ============================-->
  <footer id="footer">
    <div class="footer-top">
      <div class="container">
        <div class="row">

    
          <div class="col-lg-2 col-md-6 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><a [routerLink]="['/home']">Home</a></li>
              <li><a [routerLink]="['/about-us']">About us</a></li>
              <li><a [routerLink]="['/services']">Services</a></li>
              <li><a [routerLink]="['/careers']">Careers</a></li>
              <li><a [routerLink]="['/blog']">Blog</a></li>
              <li><a [routerLink]="['/contact-us']">Contact</a></li>
            </ul>
          </div>
          <div class="col-lg-3 col-md-6 footer-links">
            <h4>Products</h4>
            <ul>
              <li><a [routerLink]="['/retail-pos-system']">Pos System</a></li>
              <li><a [routerLink]="['/lottery-management-software']">Lottery Sales</a></li>
              <li><a [routerLink]="['/banking']">Retail Banking</a></li>
              <li><a [routerLink]="['/account-payable-software']">Account Payable</a></li>
              <li><a [routerLink]="['/utility-billing']">Utility Billing</a></li>
            </ul>
          </div>

          <div class="col-lg-4 col-md-6 footer-contact">
              <h4>Contact Us</h4>
              <p>
                502 Palisade Ave <br>
                Jersey City, NJ 07307<br>
                United States <br>
                <strong>Phone:</strong> +1 (201) 564-0454<br>
                <strong>Email:</strong> info@shreemon.com<br>
              </p>
            </div>

          <div class="col-lg-3 col-md-6 footer-contact">
            <h4></h4>
           <p></p>
            <p>
              5/1 Chaitanya Society <br>
              S. B. Road, Pune 411016<br>
              India <br>
              <strong>Phone:</strong> +91 25-670-597<br>
              <strong>Email:</strong> info@shreecominfotech.com<br>
            </p>
            <div class="social-links">
              <a href="#" class="twitter"><i class="fa fa-twitter" title="Twitter"></i></a>
              <a href="#" class="facebook"><i class="fa fa-facebook" title="http://www.facebook.com/shreepos/"></i></a>             
              <a href="#" class="linkedin"><i class="fa fa-linkedin" title="Linkedin"></i></a>
            </div>

          </div>

                 </div>
      </div>
    </div>

    <div class="container">
      <div class="copyright">
        &copy; Copyright <strong>SHREEMON</strong>. All Rights Reserved
      </div>
      <div class="credits">      
        Designed by <a href="https://shreemon.com/">SHREEMON</a>
      </div>
    </div>
  </footer><!-- #footer -->

  <a href="#" class="back-to-top"><i class="fa fa-chevron-up"></i></a>
  <!-- Uncomment below i you want to use a preloader -->
  <!-- <div id="preloader"></div> -->

  <!-- JavaScript Libraries -->
  <script src="../assets/lib/jquery/jquery.min.js"></script>
  <script src="../assets/lib/jquery/jquery-migrate.min.js"></script>
  <script src="../assets/lib/bootstrap/js/bootstrap.bundle.min.js"></script>
  <script src="../assets/lib/easing/easing.min.js"></script>
  <script src="../assets/lib/mobile-nav/mobile-nav.js"></script>
  <script src="../assets/lib/wow/wow.min.js"></script>
  <script src="../assets/lib/waypoints/waypoints.min.js"></script>
  <script src="../assets/lib/counterup/counterup.min.js"></script>
  <script src="../assets/lib/owlcarousel/owl.carousel.min.js"></script>
  <script src="../assets/lib/isotope/isotope.pkgd.min.js"></script>
  <script src="../assets/lib/lightbox/js/lightbox.min.js"></script>
  <!-- Contact Form JavaScript File -->
  <script src="contactform/contactform.js"></script>

  <!-- Template Main Javascript File -->
  <script src="../assets/js/main.js"></script>
